<script>
  import AtomLabel from "@/components/atoms/AtomLabel.vue";
  import AtomInput from "@/components/atoms/AtomInput.vue";
  import AtomStatusButton from "@/components/atoms/AtomStatusButton.vue";
  import Paragraph from "../atoms/Paragraph.vue";

  export default {
    name: "CredentialField",
    components: { AtomLabel, AtomInput, AtomStatusButton, Paragraph },
    props: {
      variant: { type: String, default: "primary" },
      styles: { type: Object, default: () => ({}) },
      errorMessage: { type: String, default: "" },
      invalid: { type: Boolean, default: false },
      placeholder: { type: String, default: "" },
      label: { type: String },
      value: { type: String },
      type: { type: String, default: "text" },
      idInput: { type: String, default: "" },
      showBtns: { type: Boolean, default: false },
    },

    data() {
      return {
        dirty: false,
        statusButton: "pencil",
        showPencil: false,
        uniqueId: `cred-${Math.random()
          .toString(36)
          .substr(2, 9)}`,
      };
    },
    computed: {
      id() {
        return `cred-${this.uniqueId}`;
      },
      showBtnStatus() {
        if (!this.showBtns) return false;

        return this.statusButton !== "pencil" || this.showPencil;
      },
    },
    methods: {
      onChangeInput(e) {
        this.dirty = true;
        const value = e.target.value;

        this.$emit("input", { value, id: this.idInput });

        this.statusButton = value.length ? "saved" : "pencil";
      },
    },
  };
</script>

<template>
  <div class="credential-field" :class="{ 'credential-field--invalid': dirty && invalid }">
    <AtomLabel :for-id="id" class="credential-field__label">{{ label }}</AtomLabel>

    <div class="credential-field__actions" :style="styles.label" @mouseenter="showPencil = true" @mouseleave="showPencil = false">
      <AtomInput :id="id" :type="type" :value="value" :variant="variant" class="credential-field__input" @input="onChangeInput" :placeholder="placeholder" />

      <AtomStatusButton v-if="showBtnStatus" class="credential-field__statusButton" :status="statusButton" @click="$emit('onSave')" />
    </div>

    <Paragraph v-if="dirty && invalid" :text="errorMessage" variant="alert" />
  </div>
</template>

<style lang="scss">
  .credential-field {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 2.5px 0;

    &__label {
      flex: 0 0 60px;
      cursor: default;
      color: #454545;
      font-family: $newFont_medium;
      font-size: 16px;
      font-weight: 500;
    }

    &__input {
      font-family: $newFont_regular;
      font-size: 16px;
      flex: 1;

      outline: none;
      border: none;
      color: #212121;

      &.atom-input--disabled {
        background: transparent;
        border: 0;
        padding-left: 0;
      }
    }

    .credential-field__statusButton {
      background: transparent;
    }

    .status-btn--saved {
      background: $primary-color;
      color: #fff;
    }

    .atomIconic-btn--saved {
      color: #fff;
    }
    .Paragraph--alert {
      font-family: $newFont_regular;
      grid-column: 2;
      grid-row: 2;
    }

    &__actions {
      @include Flex(row, center);
      padding-right: 5px;
      width: 300px;
      background: #f8f8f8;
      border-radius: 6px;

      &:hover,
      &:focus-within {
        outline: 1px solid #cbcbcb;
        background: #fff;

        .credential-field__input {
          background: #fff;
        }

        .status-btn__icon--edit {
          display: block;
          background: transparent;
        }
      }
    }
  }
</style>
